// extracted by mini-css-extract-plugin
export default {"container":"MCPFlowsScreen_container__XFLFW","tabContent":"MCPFlowsScreen_tabContent__3Yo3h"};